import * as React from 'react';

const SvgComponent = (props) => (
  <svg width="2em" height="2em" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.06 18.06a1.5 1.5 0 0 1 0-2.12L15.91 1.09a1.5 1.5 0 1 1 2.121 2.121L3.182 18.061a1.5 1.5 0 0 1-2.121 0Z"
      fill="#201749"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.06 1.06a1.5 1.5 0 0 1 2.122 0L18.03 15.91a1.5 1.5 0 1 1-2.121 2.121L1.06 3.182a1.5 1.5 0 0 1 0-2.121Z"
      fill="#201749"
    />
  </svg>
);

SvgComponent.propTypes = {};

export default SvgComponent;
